import { useQuery } from 'react-query';
import { WhatsappTemplatesResponse } from '@bandido/shared/types';
import { client } from '@frontend/features/common/services';
import { QueryKeys } from '@frontend/features/common/types';

const fetchTemplates = async (agencyId: number): Promise<WhatsappTemplatesResponse> => {
  const { data } = await client.get(`/whatsapp/templates/${agencyId}`); // asumimos un proxy backend
  return data;
};

export const useGetTemplates = (agencyId?: number) =>
  useQuery([QueryKeys.gupshupTemplates, agencyId], () => fetchTemplates(agencyId as number), {
    enabled: Boolean(agencyId),
    // Temporary mitigation for templates OOM debugging.
    retry: 0,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000,
  });
